import React from "react";
import styles from './textoPerdedor.module.css'


const TextoPerdedor = () => {


    return(
        <div className={styles.textoGanador}>
            <h2>¡UPPPSS! </h2>
            <p> El código que enviaste no es válido o lo escribiste mal. <br className={styles.br}></br>
                Por favor, intenta con otro código.</p>
        </div>
    )
}



export default TextoPerdedor